import { createStyles, makeStyles, Theme, Divider } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>createStyles({
  root: {
    display: 'flex',
    fontFamily: 'Roboto',
    padding: '8px',
    fontSize: 14,
    '& div': {
      padding: '2px 6px',
      cursor: 'pointer',
      color: 'common.white',
      backgroundColor: '#1C1C1C',
      borderRadius: '6px',
    },
    '& .MuiDivider-root': {
      backgroundColor: theme.palette.common.white,
    }
  },
  active: {
    backgroundColor: 'rgba(117, 117, 117, .12)',
    color: 'white',
    borderRadius: 4
  }
}));

interface OwnProps {
  readonly user?: string;
  readonly opponent?: string;
  readonly view?: string;
  readonly onSelect: (filter: string) => void;
  readonly filter?: string;
}

type Props = OwnProps;

const LineupFilter = (props: Props) => {
  const { user, opponent, view, filter, onSelect } = props;
  const [selected, setSelected] = React.useState(filter)
  const classes = useStyles();

  const handleSelect = (selection: string) => {
    setSelected(selection);
    onSelect(selection);
  }
  
  React.useEffect(() => {
    setSelected(filter);
  }, [view])
  return (
    <div className={classes.root}>
      <div className={selected === 'all' ? classes.active: ''} onClick={() => handleSelect('all')}>All</div>
      {
        user && ['user', 'lineup', 'player', 'stack'].indexOf(view || '') > -1 && (
          <>
            <Divider orientation='vertical' light flexItem />
            <div className={selected === 'user' ? classes.active: ''} onClick={() => handleSelect('user')}>{user}</div>
            <Divider orientation='vertical' light flexItem /> 
          </>
        )
      }
      {
        opponent && ['lineup', 'player', 'stack'].indexOf(view || '') > -1 && (
          <div className={selected === 'opp' ? classes.active: ''} onClick={() => handleSelect('opp')}>{opponent}</div>
        )
      }
    </div>
  )
}

export default LineupFilter